module.exports = __webpack_public_path__ + "img/corchete-bienvenido.4790a445.svg";